import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home'
import CorporateTravel from '../pages/CorporateTravel'
import IncentiveTravel from '../pages/IncentiveTravel'
import Conference from '../pages/Conference'
import ServiceExperience from '../pages/ServiceExperience'
import ServiceCase from '../pages/ServiceCase'
import News from '../pages/News'
import NewsDetails from '../pages/NewsDetails'
import AboutUs from '../pages/AboutUs'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: '首页',
      component: Home
    },
    {
      path: '/corporateTravel',
      name: '企业差旅',
      component: CorporateTravel
    },
    {
      path: '/incentiveTravel',
      name: '奖励旅游',
      component: IncentiveTravel
    },
    {
      path: '/conference',
      name: '会务会展',
      component: Conference
    },
    {
      path: '/serviceExperience',
      name: '增值服务',
      component: ServiceExperience
    },
    {
      path: '/serviceCase',
      name: '公务机票',
      component: ServiceCase
    },
    {
      path: '/news',
      name: '新闻资讯',
      component: News
    },
    {
      path: '/newsDetails',
      name: '资讯详情',
      component: NewsDetails
    },
    {
      path: '/aboutUs',
      name: '关于我们',
      component: AboutUs
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js